import React from 'react'

import { IcfDocumentSetListRenewal } from './list-renewal'
import { useIcfDocumentSetList } from './list.hooks'
import { useIcfDocumentHospital } from '../../use-icf-document-hospital'

export const IcfDocumentSetListContainer: React.FC = () => {
  const { icfDocumentSetList, canAddDocumentSet } = useIcfDocumentSetList()

  const { selectedTrialHospitalUid } = useIcfDocumentHospital()

  return (
    <IcfDocumentSetListRenewal
      icfDocumentSetList={icfDocumentSetList}
      canAddDocumentSet={canAddDocumentSet}
      selectedTrialHospitalUid={selectedTrialHospitalUid}
    />
  )
}
